import { request } from "../utils/request.js"


export const tenant_register = (pojo, args) => request({
    url: 'tenant/register',
    method: 'POST',
    params: pojo,
    showSuccessModal: true,
    showFailMessage: true,
    ...args
})



// WEBPACK FOOTER //
// ./src/api/tenant.js